import {getSafeLocation} from './safe';
import store from '../store/index.js';


import sm2 from './sm/sm2';
import sm3 from './sm/sm3';

let appsecret = window.Config.appsecret,
    sm2secret = window.Config.sm2secret;

export function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split('=').map((c) => c.trim());
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return '';
}

// 返回完整的WebContent根路径
export function getRootPath() {
    let loc = getSafeLocation(),
        host = loc.hostname,
        protocol = loc.protocol,
        port = loc.port ? ':' + loc.port : '',
        path = '/' + loc.pathname.split('/')[1] + '/';

    let rootPath = protocol + '//' + host + port + path;

    return rootPath;
}

export function dateFormat(date, fmt, preWrapStr, sufWrapStr) {
    let o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, //小时
        'H+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
    };
    let week = {
        0: '\u65e5',
        1: '\u4e00',
        2: '\u4e8c',
        3: '\u4e09',
        4: '\u56db',
        5: '\u4e94',
        6: '\u516d'
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            (preWrapStr || '') + RegExp.$1 + (sufWrapStr || ''),
            (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        );
    }
    if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
            (preWrapStr || '') + RegExp.$1 + (sufWrapStr || ''),
            (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + '']
        );
    }
    for (let k in o) {
        if (new RegExp('(' + (preWrapStr || '') + k + (sufWrapStr || '') + ')').test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.replace(preWrapStr || '', '').replace(sufWrapStr || '', '').length === 1
                    ? o[k]
                    : ('00' + o[k]).substr(('' + o[k]).length)
            );
        }
    }
    return fmt;
}

export function objKeySort(arys) {
    // 先用Object内置类的keys方法获取要排序对象的属性名数组，再利用Array的sort方法进行排序
    let newkey = Object.keys(arys).sort();
    let newObj = ''; // 创建一个新的对象，用于存放排好序的键值对

    for (let i = 0; i < newkey.length; i++) {
        // 遍历newkey数组
        newObj += [newkey[i]] + '=' + arys[newkey[i]] + '&';
    }

    return newObj.substring(0, newObj.length - 1);
}

export function getSign(params) {
    let data = {};
    for (let key in params) {
        let value = params[key];
        if (typeof value === 'object') {
            let str = '{';
            for (let k in value) {
                str += k + '=' + value[k] + ', ';
            }
            str = str.substring(0, str.length - 2) + '}';
            value = str;
        }
        data[key] = value;
    }

    let sortData = objKeySort(data) + '&appsecret=' + appsecret;
    let sign = sm3.encrypt(sortData);
    return sign;
}

export function getParams(params) {
    let dataStr = JSON.stringify(params);
    let paramgm = sm2.encrypt(dataStr, sm2secret, 0);
    return paramgm;
}

export function getMaterialTypesData(data) {
    return data.map((item) => {
        const newItem = {
            label: item.typename,
            value: item.typecode,
            parentValue: item.parenttypecode
        };

        if (item.childrenlist && item.childrenlist.length > 0) {
            newItem.children = getMaterialTypesData(item.childrenlist);
        }
        return newItem;
    });
}

/**
 * 生成一个符合RFC 4122标准的UUID（GUID）
 * @returns {string} 返回一个GUID字符串
 */
export function createGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export function getRequestParams(params) {
    let paramsData = {
        appkey: window.Config.appkey,
        platformcode: window.Config.platformcode,
        timestamp: new Date().getTime(),
        ...params
    };
    paramsData.sign = getSign(paramsData);
    return paramsData;
}

export function getRedirectUrl(url, params = {}) {
    let hasParams = /.*\?/.test(url);
    if (hasParams) {
        if (url.split('').pop() !== '&') {
            url += '&';
        }
    } else {
        url += '?';
    }
    let keys = Object.keys(params);
    keys.forEach((key, index) => {
        url += key + '=' + params[key];
        if (index < keys.length - 1) {
            url += '&';
        }
    });
    return url;
}

export function getAutologinandredirectUrl(params) {
    /**
     * params
     * {
     *   userguid:'',
     *   redirecturl:‘’
     * }
     */
    if (!params.redirecturl) {
        return '';
    }
    let url = window.service.autologinandredirect.url + '?';
    let paramsData = getRequestParams(params);
    paramsData.redirecturl = encodeURIComponent(paramsData.redirecturl);
    let keys = Object.keys(paramsData);
    keys.forEach((key, index) => {
        url += key + '=' + paramsData[key];
        if (index < keys.length - 1) {
            url += '&';
        }
    });
    return url;
}

// 获取文件名后缀名
export function getFileNameExtension(fileName) {
    return fileName.match(/\.([^.]+)$/)[1];
}

export function getUrlParam(name){
    let params_str = location.search.substring(1);
    let reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
    let result = params_str.match(reg);
    if (result === null) {
        return null;
    }
    // 对编码过 URI 进行解码
    return decodeURIComponent(result[2]);
}

export function downloadAttach(url) {
    if (store.getters.platform === 'DesktopApp') {
        window.open(url, '_blank');
    } else {
        parent.postMessage(
            {
                type: 'utilBridge',
                method: 'openWebPage',
                params: {openType: '1', url},
                callbackId: createGuid()
            },
            '*'
        );
    }
}